export default {
  login: {
    title: 'เข้าสู่ระบบ mypage',
    double_check_text: 'ข้อมูลไม่ถูกต้อง โปรดยืนยันว่าคุณป้อนข้อมูลที่ถูกต้องแล้ว',
    id_email: 'ID/ที่อยู่อีเมล',
    password: 'รหัสผ่าน',
    password_display: 'แสดงรหัสผ่าน',
    password_no_display: 'ซ่อนรหัสผ่าน',
    login: 'เข้าสู่ระบบ',
    keep_login_text: 'รักษาสถานะการเข้าสู่ระบบ',
    forgot_password_text: 'ลืมรหัสผ่าน',
    contact_us: 'ลงทะเบียนที่นี่',
    asuene_service_outline: '"ASUENE" บริการคลาวด์แสดงภาพ CO2',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: 'แพลตฟอร์มการสรรหาบุคลากรที่เน้นผู้มีความสามารถ GX/ESG "ASUENE CAREER"',
    corporate_page: 'เว็บไซต์ของบริษัท',
    // cross_use: {
    //   title: '',
    //   asuene_product: {
    //     banner_title: '',
    //     flag_text: '',
    //     left_btn_label: '',
    //     left_btn_link: '',
    //     right_btn_label: '',
    //     right_btn_link: '',
    //   },
    //   footer_note: ''
    // }
  },
}
